import { render, staticRenderFns } from "./DatafastTokensHistory.vue?vue&type=template&id=82eecb30&scoped=true"
import script from "./DatafastTokensHistory.vue?vue&type=script&lang=js"
export * from "./DatafastTokensHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82eecb30",
  null
  
)

export default component.exports